export const CUSTOMIZATION_UPDATE = 'customization/UPDATE';
export const CUSTOMIZATION_UPDATE_DATA = 'customization/UPDATE_DATA';
export const CUSTOMIZATION_UPDATE_ERROR = 'customization/UPDATE_ERROR';
